import React, { useEffect, useState } from "react";
import { Button, ButtonToolbar, Loader, Container, Modal } from "rsuite";
import { UtilityServices } from "../../../core/services/UtilityServices";
import "./Brands.css";
import { useTranslation } from "react-i18next";
import { get } from "lodash/fp";
import Brands from "./Brands";
import { BrandFields, BrandListParams } from "./BrandDataTypes";

const BrandsModal = ({
  companyId,
  storeId,
  openModal,
  setOpenModal,
  onSelectBrand,
  ...props
}: {
  companyId?: number;
  storeId?: number;
  openModal: boolean;
  setOpenModal: Function;
  onSelectBrand?: Function;
}) => {
  const { t } = useTranslation();

  const [loader, setLoader] = useState(false);

  return (
    <div className="modal-container">
      {loader && (
        <Loader
          style={{ zIndex: 9999 }}
          size="lg"
          content={t("LOADING")}
          center
          backdrop={true}
        />
      )}
      <Modal
        open={openModal}
        backdrop={false}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="lg"
        className="entity-picker-modal"
      >
        <Modal.Header>
          <h4 className="text-center entity-picker-title">
            {t("SELECT")} {t("OR")} {t("ADD")} {t("BRAND")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="add-brand entity-picker-body">
            <Brands
              withHeader={false}
              forComp={companyId}
              onSelectBrand={onSelectBrand}
              multiSelect={false}
              showCreateForm={false}
            />
            <ButtonToolbar className="btn-center entity-picker-footer">
              <Button
                onClick={(e: any) => setOpenModal("")}
                color="red"
                appearance="primary"
              >
                {t("CLOSE")}
              </Button>
            </ButtonToolbar>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default BrandsModal;
